module.exports = __webpack_public_path__ + "img/index-b-slide2.e24c5de2.jpg";